import { getStore, setStore } from '../config/global';
import { 
    ADD_TODO,
    DELETE_TODO,
    SELECT_ALL_TODO,
    DELETE_FINISHED_TODO
} from './mutations-type';

export default {
    //ADD_TODO并不是方法名，
     [ADD_TODO](state,{todo}){
        state.todos.unshift(todo)
     },
     [DELETE_TODO](state,{index}){
        state.todos.splice(index,1)
     },
     [SELECT_ALL_TODO](state,{isCheck}){
        state.todos.forEach(item =>item.finished = isCheck)
     },
     [DELETE_FINISHED_TODO](state){
        state.todos = state.todos.filter(item =>{
            return item.finished == false
        })
     }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js